import { METRICA_ID } from '@components/utilComponents/YandexMetricaManager';

/**
 * Диалог «подать заявку на инвестиции» — цель считается только по нему,
 * поэтому id триггерного сообщения зашит так же, как был в админке CarrotQuest.
 */
const INVEST_REQUEST_MESSAGE_ID = '1682319491507160228';

const MESSENGER_OPENED = 'messenger_opened';
const CONVERSATION_STARTED = 'conversation_started';
const CONVERSATION_OPENED = 'conversation_opened';

const isInvestRequestConversation = (payload?: unknown) =>
  typeof payload === 'object' &&
  payload !== null &&
  'message' in payload &&
  (payload as { message?: unknown }).message === INVEST_REQUEST_MESSAGE_ID;

/**
 * Мост «событие виджета CarrotQuest → цель Яндекс Метрики». Раньше жил строкой
 * в админке CarrotQuest и исполнялся через `eval`, под CSP перестал работать —
 * поэтому переехал в бандл (AI-102).
 *
 * @example
 * const stopGoals = setUpMetricaGoals();
 * stopGoals();
 */
export const setUpMetricaGoals = () => {
  const handleMessengerOpened = () => {
    globalThis.carrotquest?.track('Клик чат');
    globalThis.ym?.(METRICA_ID, 'reachGoal', 'ChatOpened');
  };

  const handleConversationStarted = () => {
    globalThis.ym?.(METRICA_ID, 'reachGoal', 'ConversationStarted');
  };

  const handleConversationOpened = (...parameters: unknown[]) => {
    if (isInvestRequestConversation(parameters[0])) {
      globalThis.ym?.(METRICA_ID, 'reachGoal', 'Chat_invest_request');
    }
  };

  globalThis.carrotquest?.addCallback(MESSENGER_OPENED, handleMessengerOpened);
  globalThis.carrotquest?.addCallback(
    CONVERSATION_STARTED,
    handleConversationStarted,
  );
  globalThis.carrotquest?.addCallback(
    CONVERSATION_OPENED,
    handleConversationOpened,
  );

  // Сшивка профиля CarrotQuest с визитом в Метрике: без неё в карточке диалога
  // не видно, из какой рекламной кампании пришёл человек.
  globalThis.ym?.(METRICA_ID, 'getClientID', (clientId: string) => {
    globalThis.carrotquest?.identify([
      { op: 'set_once', key: 'yclid', value: `yclid${clientId}` },
    ]);
  });

  return () => {
    globalThis.carrotquest?.removeCallback(
      MESSENGER_OPENED,
      handleMessengerOpened,
    );
    globalThis.carrotquest?.removeCallback(
      CONVERSATION_STARTED,
      handleConversationStarted,
    );
    globalThis.carrotquest?.removeCallback(
      CONVERSATION_OPENED,
      handleConversationOpened,
    );
  };
};
